import cn from 'classnames';
import { useStore } from '@lib/state-engine';
import { WarehouseMap } from '../map';
import { WarehouseList } from '../list';
import { $viewMode } from '../model';
// import { ContextMenu } from '@consta/uikit/ContextMenu';

import styles from './styles.module.css';
// import { useRef } from 'react';

export const WarehouseViewer = () => {
  const viewMode = useStore($viewMode);

  const isMapMode = viewMode.value === 'map';
  const isListMode = viewMode.value === 'list';

  return (
    <div className={cn([styles.viewer])}>
      <WarehouseMap className={cn([styles.map, { [styles.hidden]: !isMapMode }])} />
      {isListMode && (
        <WarehouseList
          className={cn([styles.list, { [styles.hidden]: !isListMode }])}
        />
      )}
    </div>
  );
};
